import { AdminPageContent } from "@/components/admin";
import { Outlet } from "react-router";

const AdminSettings = () => {
    return (
        <AdminPageContent>
            <Outlet />
        </AdminPageContent>
    );
};

export default AdminSettings;
